// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import App from './App';
import './index.css';

import GlobalErrorBoundary from './components/common/GlobalErrorBoundary';
import axiosClient from './api/axiosClient';
// Create a client for React Query (Handles caching/real-time)
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ✅ WRAP EVERYTHING inside GlobalErrorBoundary */}
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </GlobalErrorBoundary>
  </React.StrictMode>
);

window.onerror = function (message, source, lineno, colno, error) {
  axiosClient.post('/admin/system/error-vault-log', {
    source: 'ui',
    message: String(message),
    meta: { source, lineno, colno }
  }).catch(() => {});
};

window.onunhandledrejection = function (event) {
  axiosClient.post('/admin/system/error-vault-log', {
    source: 'ui',
    message: 'Unhandled Promise Rejection',
    meta: { reason: String(event.reason) }
  }).catch(() => {});
};